export const allApplicationsRegex = /^All Application \(\d+\)$/;
export const resultModuleRegex = /\s*\(\d+\)$/;
export const resultCountRegex = /\((\d+)\)/;
